import React from 'react';

export default (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M24 0H0V24H24V0Z" fill="white" fillOpacity="0.01" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 2.40426C6.70042 2.40426 2.40426 6.70042 2.40426 12C2.40426 17.2996 6.70042 21.5957 12 21.5957C17.2996 21.5957 21.5957 17.2996 21.5957 12C21.5957 6.70042 17.2996 2.40426 12 2.40426ZM1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12ZM12 7.5533C12.3878 7.5533 12.7021 7.86765 12.7021 8.25543V11.2978H15.7447C16.1325 11.2978 16.4468 11.6121 16.4468 11.9999C16.4468 12.3877 16.1325 12.702 15.7447 12.702H12.7021V15.7448C12.7021 16.1326 12.3878 16.4469 12 16.4469C11.6122 16.4469 11.2979 16.1326 11.2979 15.7448V12.702H8.25532C7.86754 12.702 7.55319 12.3877 7.55319 11.9999C7.55319 11.6121 7.86754 11.2978 8.25532 11.2978H11.2979V8.25543C11.2979 7.86765 11.6122 7.5533 12 7.5533Z"
      fill="currentColor"
    />
  </svg>
);
